import React, { SetStateAction } from "react";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
interface Props {
  label?: string;
  placeholder?: string;
  value: string;
  setValue: React.Dispatch<SetStateAction<string>>;
}

function MultiLineTextInput({ label, placeholder, value, setValue }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <Label>{label}</Label>
      <Textarea
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
}

export default MultiLineTextInput;
